var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileSiren(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_252_6691)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 4.8735L15 3.23413",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 20L15 15",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9453 7.1885L22.9469 6.18695",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.05487 7.1885L6.92383 6.18695",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.77344 19.5351V15.6768C7.77341 14.6585 7.96214 13.6502 8.32874 12.7101C8.69534 11.7701 9.23257 10.9168 9.90945 10.1994C10.5863 9.48209 11.3895 8.91492 12.2726 8.5306C13.1557 8.14629 14.1013 7.95242 15.0549 7.96019C19.0394 7.99202 22.2263 11.5185 22.2263 15.7733V19.5351",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.9489 20.1095H7.05077C6.65166 20.1095 6.32812 20.455 6.32812 20.8812V23.1961C6.32812 23.6223 6.65166 23.9678 7.05077 23.9678H22.9489C23.348 23.9678 23.6715 23.6223 23.6715 23.1961V20.8812C23.6715 20.455 23.348 20.1095 22.9489 20.1095Z",
    stroke: "currentColor",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_252_6691"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileSiren);
export default __webpack_public_path__ + "static/media/mobile-siren.d099cde41c9d3f9d54d86d2480510715.svg";
export { ForwardRef as ReactComponent };